
      var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMusic = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30 69.545V15a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v90a5 5 0 0 1-5 5H50m20-85H50",
  stroke: "#fff",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.029 90.167c4.567-11.116-.418-17.92-8.23-21.435-2.738 10.909-5.804 23.758-7.867 30.845-1.63 5.594-7.699 8.868-13.847 7.231-6.148-1.637-9.915-7.529-8.416-13.16 1.5-5.63 7.699-8.868 13.846-7.231 3.37.897 5.307 3.165 6.024 4.808 3.58-14.045 7.423-29.273 9.392-37.068.739-2.923 1.769-3.418 2.862-3.127 1.71.455 1.208 2.567 1.487 3.686.67 3.142 3.41 4.126 6.004 6.12 4.193 3.223 6.598 9.143 6.143 15.128-.42 5.536-3.273 10.957-7.398 14.203Z",
  fill: "url(#music_702ffd5ec00edfb1__a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "music_702ffd5ec00edfb1__a",
  x1: 52.719,
  y1: 51.01,
  x2: 37.281,
  y2: 108.99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})))));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M30 69.5452V15C30 12.2386 32.2386 10 35 10H85C87.7614 10 90 12.2386 90 15V105C90 107.761 87.7614 110 85 110H50M70 25H50\" stroke=\"white\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M59.0289 90.1671C63.5963 79.0507 58.6112 72.2468 50.7993 68.7317C48.061 79.6406 44.9947 92.4904 42.9316 99.5766C41.3024 105.171 35.2331 108.445 29.0853 106.808C22.9375 105.171 19.1697 99.279 20.6691 93.6481C22.1684 88.0172 28.3676 84.7798 34.5154 86.4167C37.8844 87.3138 39.8219 89.5819 40.5386 91.2255C44.1192 77.1802 47.9621 61.9519 49.9312 54.1568C50.6699 51.2341 51.6996 50.7389 52.7934 51.0301C54.503 51.4854 54.0012 53.5968 54.2797 54.7163C54.9494 57.8584 57.6897 58.8416 60.284 60.8353C64.4773 64.059 66.8816 69.9794 66.427 75.9639C66.0072 81.5002 63.1543 86.9205 59.0291 90.1666L59.0289 90.1671Z\" fill=\"url(#paint0_linear_8615_194774)\"/>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_8615_194774\" x1=\"52.7192\" y1=\"51.0104\" x2=\"37.2808\" y2=\"108.99\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.508104\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/music.702ffd5ec00edfb19f6b3eefb14d2fd7.svg"),
        {
          React: SvgMusic,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      